module.exports = __webpack_public_path__ + "img/Thumbnail2.4a3c8312.png";